import { exports as toPrimitiveExports, __module as toPrimitive } from '../../../../_virtual/toPrimitive.js';
import './typeof.js';
import { exports as _typeofExports } from '../../../../_virtual/typeof.js';

var hasRequiredToPrimitive;

function requireToPrimitive () {
	if (hasRequiredToPrimitive) return toPrimitiveExports;
	hasRequiredToPrimitive = 1;
	(function (module) {
		var _typeof = _typeofExports["default"];
		function _toPrimitive(input, hint) {
		  if (_typeof(input) !== "object" || input === null) return input;
		  var prim = input[Symbol.toPrimitive];
		  if (prim !== undefined) {
		    var res = prim.call(input, hint || "default");
		    if (_typeof(res) !== "object") return res;
		    throw new TypeError("@@toPrimitive must return a primitive value.");
		  }
		  return (hint === "string" ? String : Number)(input);
		}
		module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (toPrimitive));
	return toPrimitiveExports;
}

export { requireToPrimitive as __require };
//# sourceMappingURL=toPrimitive.js.map
